import { Injectable } from '@angular/core';
import { DeviceService } from '../shared/services/device.service';
import { DynamicControlsSharedStateService } from '../shared/services/dynamic-controls-shared-state.service';
import { IControlInput, IDynamicControlsSharedState } from '../shared/models/device';
import { IDisplayInfo } from '../shared/models/models';
import { DynamicDeviceModel } from '../shared/models/dynamic-device-model';

@Injectable({
    providedIn: 'root',
})
export class DynamicDeviceModelService {
    public static $name = 'dynamicDeviceModelService';

    private dynamicDeviceModel = new DynamicDeviceModel();
    private sharedState: IDynamicControlsSharedState;

    constructor(private dynamicControlsSharedStateFactory: DynamicControlsSharedStateService,
                private deviceService: DeviceService) {
        this.sharedState = this.dynamicControlsSharedStateFactory.create();
    }

    public getDisplayInfo(viewModel: CASLink.Device.Ui.ViewModel.DynamicControls.ControlSummaryViewModel): IDisplayInfo {
        let displayInfo = this.dynamicDeviceModel.getDisplayInfo(viewModel);

        displayInfo.dataViewModel.forEach(m => {
            if (!m || !m.data) {
                return;
            }
            let controlInput = m.data as IControlInput;

            controlInput.$fieldName = this.sharedState.nextId();
            this.deviceService.setControlInputType(controlInput);
            m.$controlInput = controlInput;
        });

        return displayInfo;
    }

}
